import { RouteConfig } from "vue-router";

const routes: RouteConfig[] = [
  {
    path: "/",
    redirect: "/professional"
  },
  {
    path: "/professional",
    meta: {
      requiresAuth: true
    },
    component: () => import("@/layouts/ProfessionalLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("@/pages/professional/Index.vue"),
        name: "professional-index",
        meta: {
          title: "Pacientes"
        }
      },
      {
        path: ":patientId",
        name: "professional-patient",
        component: () => import("@/pages/professional/PatientPage.vue"),
        props: true,
        meta: {
          title: "Paciente"
        }
      }
      //   {
      //     path: "empresas",
      //     name: "cuida-companies",
      //     component: () => import("pages/cuida/companies/Index.vue")
      //   },
      //   {
      //     path: "empresas/:companyId",
      //     name: "cuida-company-detail",
      //     component: () => import("pages/cuida/companies/Detail.vue"),
      //     props: true
      //   },
      //   {
      //     path: "empresas/:companyId/colaborador/:employeeId",
      //     name: "cuida-employee",
      //     component: () => import("pages/cuida/employee/Index.vue"),
      //     props: true
      //   },
      //   {
      //     path: "minha-conta",
      //     name: "cuida-account",
      //     component: () => import("pages/cuida/account/Index.vue")
      //   },
      //   {
      //     path: "nova-acao",
      //     name: "cuida-new-action",
      //     component: () => import("pages/cuida/action-plan/ActionForm.vue"),
      //     props: true
      //   },
      //   {
      //     path: "acao/:actionId",
      //     name: "cuida-action-details",
      //     component: () => import("pages/cuida/action-plan/ActionDetail.vue"),
      //     props: true
      //   },
      //   {
      //     path: "lista-acoes",
      //     name: "cuida-action-list",
      //     component: () => import("pages/cuida/action-plan/ActionList/Index.vue")
      //   }
    ]
  }
];

// Always leave this as last one
if (process.env.MODE !== "ssr") {
  routes.push({
    path: "*",
    component: () => import("@/pages/Error404.vue")
  });
}

export default routes;
